import { SUPPORTED_EXCHANGE } from '@/lib/configs/exchange-config'
import { Exchange } from '@/types/generated/common/types'

/**
 * The venue a surface falls back to only when it has NO venue context at all — a
 * brand-new widget with an empty watch list, a chat command for an asset with no
 * instrument data, a stream payload whose instrument hasn't loaded yet. Deribit is
 * the historical default and the venue `DEFAULT_SYMBOL` below exists on.
 *
 * This is a last resort, never a substitute for a known venue: resolve from the
 * instrument / watch-list item / account (e.g. `useAccountPrimaryExchange`) first and
 * reach for this only when every one of those is absent. Keep every such fallback
 * pointing here rather than at a scattered `'DERIBIT'` literal.
 */
export const DEFAULT_VENUE_EXCHANGE = Exchange.EXCHANGE_DERIBIT
export const DEFAULT_VENUE_KEY = SUPPORTED_EXCHANGE.DERIBIT

/** The instrument a market widget shows before anything is selected; lives on DEFAULT_VENUE. */
export const DEFAULT_SYMBOL = 'BTC-PERPETUAL'

/** `exchange` unless it is missing or EXCHANGE_UNSPECIFIED, else DEFAULT_VENUE_EXCHANGE. */
export function exchangeOrDefaultVenue(exchange: Exchange | undefined | null): Exchange {
  return exchange || DEFAULT_VENUE_EXCHANGE
}
